<template>
  <div class="col-12">
    <Breadcrumb :home="home" :model="breadcrumbitems" />
    <TabMenu :model="items" :activeIndex="activeIndex" />
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      home: { icon: 'pi pi-home', to: '/' },
      breadcrumbitems: [
        { label: 'Servidor', to: { name: 'servidores' } },
        {
          label: 'Propostas',
          to: { name: 'propostas' },
        },
        { label: 'Detalhe da proposta' },
      ],
      activeIndex: 0,
      tabIndex: {
        'proposta-detalhe': 0,
      },
      items: [{ label: 'Proposta', to: { name: 'proposta-detalhe' } }],
    }
  },

  mounted() {
    this.activeIndex = this.tabIndex[this.$route.name]
  },

  updated() {
    this.activeIndex = this.tabIndex[this.$route.name]
  },
}
</script>

<style lang="scss" scoped>
::v-deep
  .p-tabmenu
  .p-tabmenu-nav
  .p-tabmenuitem
  .p-menuitem-link:not(.p-disabled):focus {
  box-shadow: none;
}

::v-deep .p-highlight .router-link-exact-active {
  color: var(--primary-color) !important;
}

::v-deep .p-menuitem-link {
  height: 103%;
}
</style>
